import { API } from "api/axios.config";
import { useMemo } from "react";
import { createApplicationService } from "./base/applicationServiceBase";

const SUPPLIERS_BASE = "/Suppliers";
const extractData = (res) => res?.data?.data || [];

const getSuppliers = (parameters) =>
  API.get(`${SUPPLIERS_BASE}`, { params: parameters });

//  Async functions (No Redux Involvement)
const fetchSuppliersData = async (parameters) =>
  extractData(await getSuppliers(parameters));

const addSupplierData = async (data) =>
  API.post(`${SUPPLIERS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateSupplierData = async (id, data) =>
  API.patch(`${SUPPLIERS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const fetchSupplierById = async (id) =>
  (await API.get(`${SUPPLIERS_BASE}/${id}`)).data?.data;

const searchSuppliers = async (page, limit, search) =>
  extractData(
    await API.get(`${SUPPLIERS_BASE}/search`, {
      params: { page, limit, search },
    })
  );

const fetchSuppliersByRef = async (searchedVal) =>
  extractData(
    await API.get(`${SUPPLIERS_BASE}/byRef`, {
      params: { searchedVal },
    })
  );

const fetchSupplierBalances = async (
  supplierRef,
  fromDate,
  toDate,
  page = 1,
  take = 200
) => {
  const res = await API.get(`${SUPPLIERS_BASE}/Ref/${supplierRef}/Balances`, {
    params: {
      searchedVal: supplierRef,
      FromDate: fromDate,
      ToDate: toDate,
      page,
      take,
    },
  });
  return res?.data?.data || { data: [], total: 0 };
};

const fetchConsultantRefs = async () =>
  extractData(await API.get(`${SUPPLIERS_BASE}?type=Consultant&active=true`));

const baseService = createApplicationService({
  name: "suppliers",
  apiFetchFn: () => getSuppliers(),
  apiAddFn: addSupplierData,
  apiUpdateFn: updateSupplierData,
});

const supplierReducer = baseService.reducer;
const useSuppliers = baseService.useData;
const getActiveSuppliers = baseService.getData;
const addSupplier = baseService.addData;
const updateSupplier = baseService.updateData;

const useActiveSuppliers = () => {
  const { data, loading } = useSuppliers();
  const activeSuppliers = useMemo(
    () => (data || []).filter((supplier) => supplier.active),
    [data]
  );
  return { data: activeSuppliers, loading };
};

export {
  fetchSuppliersData,
  addSupplier,
  updateSupplier,
  fetchSupplierById,
  searchSuppliers,
  fetchSuppliersByRef,
  fetchSupplierBalances,
  fetchConsultantRefs,
  supplierReducer,
  useSuppliers,
  useActiveSuppliers,
  getActiveSuppliers,
};
